import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BusinessService } from '../../../common/services/Business.service';
import { ForgotPassBusinessService } from '../../../common/services/ForgotPassBusiness.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;
declare var AccountKit: any;
var that;

@Component({
  selector: 'sd-forgot-password',
  templateUrl: './forgot-password.component.html',
  providers: [BusinessService]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  public phone: string;
  public code: string;
  public password: string;
  public cpassword: string;
  public error: string;
  public requestOtp = true;
  public icheckId: string;
  public model: any = {};
  public message: { class: string, content: string } = null;
  public codeOTP: string;
  public validate_password: boolean = false;
  phone_custom;
  check: boolean;
  tokenForgot: '';
  tokenOtp: '';
  langSubscription: Subscription;
  placeholders: any = {};

  constructor(
    private toastr: ToastrService,
    public httpClient: HttpClient,
    public businessService: BusinessService,
    public forgotPassBusinessService: ForgotPassBusinessService,
    public router: Router,
    private translate: TranslateService) {
    that = this;
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('animsition');   //add the class
    body.classList.add('page-login-v3');   //add the class
    body.classList.add('layout-full');   //add the class
  }

  ngOnInit() {
    this.model.countrycode = '+84';
    $('#resetPassword1').hide();
    $('#confirmOtp1').hide();
    $('#requestPassword').show();
    // $('#resetPassword').hide();
    $('#changePassword').hide();

    this.updatePlaceholders();
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.updatePlaceholders();
    });
  }

  updatePlaceholders() {
    this.translate.get([
      'FP_NHAP_SO_DIEN_THOAI',
      'FP_MA_KICH_HOAT',
      'FP_NHAP_MAT_KHAU',
      'FP_NHAP_LAI_MAT_KHAU',
    ]).subscribe((t: any) => {
      this.placeholders = {
        phone: t['FP_NHAP_SO_DIEN_THOAI'],
        activationCode: t['FP_MA_KICH_HOAT'],
        password: t['FP_NHAP_MAT_KHAU'],
        confirmPassword: t['FP_NHAP_LAI_MAT_KHAU'],
      };
    });
  }

  ngOnDestroy() {
    let body = document.getElementsByTagName('body')[0];
    body.classList.remove('page-login-v3');
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  // loginCallback(response) {
  //   if (response.status === 'PARTIALLY_AUTHENTICATED') {
  //     var code = response.code;
  //     var csrf = response.state;
  //
  //     $('#resetPassword1').show();
  //     $('#requestPassword').hide();
  //
  //     $('#resetPassword').show();
  //     // Send code to server to exchange for access token
  //   } else if (response.status === 'NOT_AUTHENTICATED') {
  //     // handle authentication failure
  //   } else if (response.status === 'BAD_PARAMS') {
  //     // handle bad parameters
  //   }
  // }

  hideFormIcheck() {
    $('#resetPassword1').hide();
    $('#confirmOtp1').hide();
  }

  hideFormQrcode() {
    $('#changePassword').hide();
    // $('#resetPassword').hide();
  }

  smsLogin(data) {
    // console.log(data);
    // var countryCode = data.countrycode;
    // var phoneNumber = data.phone;
    // AccountKit.login(
    //     'PHONE',
    //     { countryCode: countryCode, phoneNumber: phoneNumber }, // will use default values if not specified
    //     that.loginCallback
    // );
    const phone = data.phone
    this.forgotPassBusinessService.checkAccBusiness(data).subscribe(value => {
      console.log(value);
      this.check = value.data;
      if (this.check === true) {
        // icheck
        this.forgotPassBusinessService.forgotPass(data).subscribe(value2 => {
          // console.log(value);
          if (value2.statusCode === '200') {
            this.tokenForgot = value2.data.token
            $('#confirmOtp1').show();
            $('#requestPassword').hide();
            this.hideFormQrcode()
            this.message = null;

          } else {
            this.message = { class: 'alert dark alert-danger', content: value2.message };
          }

        }, error => {
          // console.log(error);
          this.message = { class: 'alert dark alert-danger', content: error.message };
        });
      } else {
        // qrcode
        // console.log(data);
        // return;
        this.message = null;
        this.businessService.pushOTP(data).subscribe(res => {
          if (res) {
            $('#requestPassword').hide();
            $('#changePassword').show();
            this.hideFormIcheck()
          }
        }, error => {
          this.message = { class: 'alert dark alert-danger', content: error.message };
        });

      }

    }, error => {
      console.log(error);
      this.message = { class: 'alert dark alert-danger', content: error.message };
    });


  }

  changePassword(data) {
    const obj = {
      phone: this.model.phone,
      otp: data.codeOTP,
      new_password: data.password,
      confirm_new_password: data.cpassword
    };
    if (data.password !== data.cpassword) {
      this.validate_password = true;
    } else {
      this.validate_password = false;
      this.message = null;
      this.businessService.changePassword(obj).subscribe(res => {
        if (res) {
          this.router.navigate(['/login']);
        }
      }, error => {
        this.message = { class: 'alert dark alert-danger', content: error.message };
      });
    }

  }


  submitOTP(data) {
    this.smsLogin(data);
    // this.passService.requestPassword(data).toPromise().then(res => {
    //     if (res) {
    //         if (res.status == 200) {
    //             this.message = {
    //                 class: "alert dark alert-success",
    //                 content: "Đã thực hiện gửi mã OTP tới số điện thoại của bạn."
    //             };
    //             if (res.data.icheck_id) {
    //                 this.icheckId = res.data.icheck_id;
    //             }
    //         } else {
    //             this.message = {
    //                 class: "alert dark alert-danger",
    //                 content: res.status + ' : ' + res.message
    //             };
    //         }
    //         // $("#requestPassword").hide();
    //         // $("#resetPassword").show("slow");
    //     }
    // },
    //     err => {
    //         this.message = { content: err.message, class: "alert dark alert-danger" };
    //     }
    // );
  }

  resetPwd(data) {

    // $('#resetPassword').hide();
    // $('#requestPassword').show();
    // console.log('data', data)
    const body = {
      token: this.tokenOtp,
      password: data.password,
      confirmPassword: data.confirmPassword,
    };
    this.forgotPassBusinessService.forgotChange(body).subscribe(res => {
      if (res) {
        // console.log('resetPwd', res)
        if (res.statusCode === '200') {
          this.router.navigate(['/login']);
          this.message = null;
        } else {
          this.message = { class: 'alert dark alert-danger', content: res.message };
        }
      }
    }, error => {
      this.message = { class: 'alert dark alert-danger', content: error.message };
    });


    // let mData = {
    //   phone: this.model.countrycode + this.model.phone,
    //   new_password: data.password,
    //   confirm_new_password: data.confirmPassword
    //
    // };
    // this.businessService.forgotPassword(mData).toPromise().then(res => {
    //     if (res) {
    //       if (res.status == 200) {
    //         this.message = {
    //           class: 'alert dark alert-success',
    //           content: 'Tạo mới mật khẩu thành công.'
    //         };
    //         $('#password').val('');
    //         $('#confirmPassword').val('');
    //
    //         this.model.countrycode = '+84';
    //         $('#resetPassword').hide();
    //         $('#requestPassword').show();
    //       } else {
    //
    //         $('#password').val('');
    //         $('#confirmPassword').val('');
    //
    //         this.model.countrycode = '+84';
    //         $('#resetPassword').hide();
    //         $('#requestPassword').show();
    //         if (res.message) {
    //           this.message = {
    //             class: 'alert dark alert-danger',
    //             content: res.status + ' : ' + res.message
    //           }
    //         } else {
    //           // let mess = '';
    //           // for (let m of res.invalidAttributes.code) {
    //           //     mess += mess ? '. ' + m.message : m.message;
    //           // }
    //           // this.message = {
    //           //     class: "alert dark alert-danger",
    //           //     content: mess
    //           // }
    //         }
    //       }
    //     }
    //   },
    //   err => {
    //
    //     $('#password').val('');
    //     $('#confirmPassword').val('');
    //
    //     this.model.countrycode = '+84';
    //     $('#resetPassword').hide();
    //     $('#requestPassword').show();
    //     this.message = {content: err.message, class: 'alert dark alert-danger'};
    //   }
    // );
  }

  confirmOtp(data) {
    // console.log(111)
    if (!data.codeOTP) {
      this.message = { class: 'alert dark alert-danger', content: 'Bạn chwua nhập OTP' };

    }
    const body = {
      token: this.tokenForgot,
      otp: data.codeOTP,
    };
    this.forgotPassBusinessService.forgotConfirm(body).subscribe(res => {
      if (res) {
        // console.log('forgotConfirm', res)

        if (res.statusCode === '200') {
          this.tokenOtp = res.data.token
          $('#confirmOtp1').hide();
          $('#resetPassword1').show();
          this.message = null;

        } else {
          this.message = { class: 'alert dark alert-danger', content: res.message };
        }
        // this.router.navigate(['/login']);
      }
    }, error => {
      this.message = { class: 'alert dark alert-danger', content: 'OTP chưa chính xác' };
    });


    // if (this.check === true) {
    //   const body = {
    //     phone: this.model.phone,
    //     otp: data.codeOTP,
    //     old_password: data.password,
    //     password: data.cpassword,
    //     confirmed_password: data.cpassword
    //   };
    //   this.forgotPassBusinessService.sendOTPBusiness(body).subscribe(res => {
    //     if (res) {
    //       this.router.navigate(['/login']);
    //     }
    //   }, error => {
    //     this.message = {class: 'alert dark alert-danger', content: error.message};
    //   });
    //   if (data.password !== data.cpassword) {
    //     this.validate_password = true;
    //   } else {
    //     this.validate_password = false;
    //     this.message = null;
    //     this.forgotPassBusinessService.sendOTPBusiness(body).subscribe(res => {
    //       if (res) {
    //         this.router.navigate(['/login']);
    //       }
    //     }, error => {
    //       this.message = {class: 'alert dark alert-danger', content: error.message};
    //     });
    //   }
    // } else {
    //   const obj = {
    //     phone: this.model.phone,
    //     otp: data.codeOTP,
    //     new_password: data.password,
    //     confirm_new_password: data.cpassword
    //   };
    //   if (data.password !== data.cpassword) {
    //     this.validate_password = true;
    //   } else {
    //     this.validate_password = false;
    //     this.message = null;
    //     this.businessService.changePassword(obj).subscribe(res => {
    //       if (res) {
    //         this.router.navigate(['/login']);
    //       }
    //     }, error => {
    //       this.message = {class: 'alert dark alert-danger', content: error.message};
    //     });
    //   }
    // }

  }

  showHidePwa = false;
  showHidePwb = false;
  inputTypeA = 'password';
  inputTypeB = 'password';

  showHidePassword() {
    this.showHidePwa = !this.showHidePwa;
    if (this.inputTypeA == 'password') {
      this.inputTypeA = 'text';
    } else {
      this.inputTypeA = 'password';
    }
  }

  showHidePassword2() {
    this.showHidePwb = !this.showHidePwb;
    if (this.inputTypeB == 'password') {
      this.inputTypeB = 'text';
    } else {
      this.inputTypeB = 'password';
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/forgot-password.component.ts